module.exports = __webpack_public_path__ + "dimer/static/img/MrMjL.4b05f78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MrMjL.jpg
// module id = 29vA
// module chunks = 0